import clsx from "clsx";

import { BrandIcon } from "@shared/ui/brand-icon";
import { Body } from "@shared/ui/typography";

import s from "./info-badges.module.scss";

export type InfoBadgesProps = {
  location?: string | null;
  time?: string | null;
  className?: string;
};

export const InfoBadges = ({ location, time, className }: InfoBadgesProps) => {
  return (
    <span className={clsx(s.root, className)}>
      {location && (
        <span className={s.infoItem}>
          <BrandIcon
            name="location"
            fillColor="cadmium"
            strokeColor="white"
            size={16}
          />
          <Body
            size="uppercase-small"
            weight="semiBold"
            className={s.infoItemText}
          >
            {location}
          </Body>
        </span>
      )}
      {time && (
        <span className={s.infoItem}>
          <BrandIcon
            name="clock"
            fillColor="azure"
            strokeColor="white"
            size={16}
          />
          <Body
            size="uppercase-small"
            weight="semiBold"
            className={s.infoItemText}
          >
            {time}
          </Body>
        </span>
      )}
    </span>
  );
};

InfoBadges.displayName = "InfoBadges";
